import styled from 'styled-components';

import {breakpoint, colors} from 'theme';

export const BalanceCell = styled.div<{isNegative?: boolean}>`
    color: ${(p) => (p.isNegative ? colors.danger : colors.textPrimary)};
`;

export const HeaderControls = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap-reverse;

    @media (max-width: ${breakpoint.phone}) {
        margin-bottom: 20px;
    }
`;

export const NavigationWrapper = styled.div<{needMargin?: boolean}>`
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    min-width: 300px;

    @media (max-width: ${breakpoint.phone}) {
        margin-bottom: ${(p) => (p.needMargin ? '20px' : '0')};
    }
`;

export const ControlsWrapper = styled.div`
    @media (max-width: ${breakpoint.phone}) {
        flex-grow: 1;
    }
`;
